import { render, staticRenderFns } from "./CmgRewardsExtrasHeader.vue?vue&type=template&id=1f9425e6&scoped=true&lang=pug"
import script from "./cmg-rewards-extras-header.ts?vue&type=script&lang=ts&external"
export * from "./cmg-rewards-extras-header.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardsExtrasHeader.vue?vue&type=style&index=0&id=1f9425e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9425e6",
  null
  
)

export default component.exports